var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 169.92 154.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85,0C38.05,0,0,28.43,0,75.34c0,18.51,6,34.13,16,46.28L0,154.11l49.7-9.4a103.38,103.38,0,0,0,35.26,6c46.91,0,85-28.43,85-75.34S131.88,0,85,0ZM45.1,89.41a13.8,13.8,0,1,1,13.8-13.8A13.8,13.8,0,0,1,45.1,89.41ZM85,105.89c-9.34,0-16.92-5.11-16.92-11.41h33.84C101.88,100.78,94.31,105.89,85,105.89Zm39.86-16.48a13.8,13.8,0,1,1,13.8-13.8A13.8,13.8,0,0,1,124.82,89.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/talk.8afc6b574e5cb527aac9af30520f68f6.svg";
export { ForwardRef as ReactComponent };